<template>
  <div>
    <el-card
      :class="{ not_selected: !solicitud.seleccionado, selectable: esAsociacion && !solicitud.NroRemito }"
      @click.native="selectSolicitud"
    >
      <!-- ícono check -->
      <div class="iconContainer checkContainer" v-if="esAsociacion && solicitud.seleccionado">
        <i class="el-icon-check"></i>
      </div>

      <div>
        <el-row>
          <el-col :span="24">
            <!-- Icono triangulo y tag -->
            <el-row justify="space-between">
              <el-col
                :span="esAsociacion && solicitud.NroRemito && solicitud.Instancia === '1A'? 12:18"
              >
                <div
                  :class="opened ? 'triangleDown' : 'triangleRight'"
                  @click="toggleOpen"
                  ref="triangle"
                ></div>
              </el-col>
              <el-col :span="6">
                <div
                  class="iconContainer"
                  style="text-align:right !important; margin-right: 5px !important;"
                  v-if="esAsociacion && solicitud.NroRemito && solicitud.Instancia === '1A'"
                  @click="anular"
                >
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="$t('SOLICITUD_btn_anular')"
                    placement="top-start"
                  >
                    <i class="el-icon-close"></i>
                  </el-tooltip>
                </div>
              </el-col>
              <el-col :span="6" style="text-align:right !important;">
                <el-tag
                  v-if="esAsociacion"
                  :type="solicitud.NroRemito ? '' : 'warning'"
                  size="small"
                  disable-transitions
                >{{ solicitud.NroRemito ? 'Remito: ' + solicitud.NroRemito : 'Sin Remito'}}</el-tag>
              </el-col>
            </el-row>

            <!-- Contenido de la tarjeta e iconos -->
            <el-row :gutter="20" class="cardContent">
              <!-- Iconos -->
              <el-col :span="2">
                <!-- iconos solicitud -->
                <el-row>
                  <div class="iconContainer" v-if="!esAsociacion" @click="editarSolicitud">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="$t('SOLICITUD_btn_editar')"
                      placement="left-start"
                    >
                      <i class="el-icon-edit"></i>
                    </el-tooltip>
                  </div>
                </el-row>
                <el-row>
                  <div class="iconContainer" v-if="!esAsociacion" @click="borrar">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="$t('SOLICITUD_btn_borrar')"
                      placement="left-start"
                    >
                      <i class="el-icon-delete"></i>
                    </el-tooltip>
                  </div>
                </el-row>
                <!-- iconos asociación a remitos -->

                <el-row>
                  <div
                    v-if="esAsociacion && solicitud.NroRemito && solicitud.Instancia === '1A'"
                    @click="desasociar"
                  >
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="$t('SOLICITUD_btn_desasociar')"
                      placement="left-start"
                    >
                      <i class="el-icon-document-delete"></i>
                    </el-tooltip>
                  </div>
                </el-row>
                <el-row>
                  <!-- ICON FAKE -->
                  <div class="iconContainer" v-if="esAsociacion">
                    <i class="el-icon-minus" style="color:white!important;"></i>
                  </div>
                </el-row>
              </el-col>
              <!-- Datos -->
              <el-col :span="20">
                <el-row :gutter="15">
                  <el-col :span="!opened? 13 : 8">
                    <span class="greyLabel">{{$t('SOLICITUD_REMITO_nro_sol')}}:</span>
                  </el-col>
                  <el-col :span="!opened? 11 : 16">
                    <div class="blackLabel">{{solicitud.NumeroSolicitud}}</div>
                  </el-col>
                </el-row>

                <el-row :gutter="15">
                  <el-col :span="!opened? 13 : 8">
                    <span class="greyLabel">{{$t('SOLICITUD_REMITO_ns')}}:</span>
                  </el-col>
                  <el-col :span="!opened? 11 : 16">
                    <div class="blackLabel">{{solicitud.Ns | defaultEmpty}}</div>
                  </el-col>
                </el-row>

                <el-row :gutter="15" v-if="opened">
                  <el-col :span="8">
                    <span class="greyLabel">{{$t('SOLICITUD_REMITO_descripcion')}}:</span>
                  </el-col>
                  <el-col :span="16">
                    <div class="blackLabel">{{solicitud.Descripcion}}</div>
                  </el-col>
                </el-row>

                <el-row :gutter="15" v-if="opened">
                  <el-col :span="8">
                    <span class="greyLabel">{{$t('SOLICITUD_REMITO_clave')}}:</span>
                  </el-col>
                  <el-col :span="16">
                    <div class="blackLabel">{{solicitud.Clave}}</div>
                  </el-col>
                </el-row>

                <el-row :gutter="15" v-if="opened">
                  <el-col :span="8">
                    <span class="greyLabel">{{$t('SOLICITUD_REMITO_servicio_oficial')}}:</span>
                  </el-col>
                  <el-col :span="16">
                    <div class="blackLabel">{{solicitud.ServicioOficial}}</div>
                  </el-col>
                </el-row>
                <el-row :gutter="15" v-if="opened">
                  <el-col :span="8">
                    <span class="greyLabel">{{$t('SOLICITUD_REMITO_instancia')}}:</span>
                  </el-col>
                  <el-col :span="16">
                    <div class="blackLabel">{{instancia}}</div>
                  </el-col>
                </el-row>
                <el-row :gutter="15" v-if="opened">
                  <el-col :span="8">
                    <span class="greyLabel">{{$t('SOLICITUD_REMITO_tipo_servicio')}}:</span>
                  </el-col>
                  <el-col :span="16">
                    <div class="blackLabel">{{solicitud.TipoServicio}}</div>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "SolicitudCard",
  props: {
    solicitud: Object,
    esAsociacion: Boolean
  },
  data() {
    return {
      opened: false
    };
  },
  computed: {
    instancia: function() {
      if (this.solicitud.Instancia.includes("0A"))
        return this.$t("INSTANCIA_PENDIENTE_ASOCIAR");
      if (this.solicitud.Instancia.includes("1A"))
        return this.$t("INSTANCIA_PENDIENTE_ENVIAR");
      if (this.solicitud.Instancia.includes("2A"))
        return this.$t("INSTANCIA_ENVIADO");
      if (this.solicitud.Instancia[0] == "Z")
        return this.$t("INSTANCIA_HISTORICO");
      return this.$t("INSTANCIA_PROCESO");
    }
  },
  methods: {
    toggleOpen(event) {
      event.stopPropagation();
      this.opened = !this.opened;
    },

    editarSolicitud(event) {
      event.stopPropagation();
      this.$emit("editar", this.solicitud.IdSolicitud);
    },

    selectSolicitud(event) {
      event.stopPropagation();

      if (this.solicitud.Instancia !== "0A") {
        return;
      }

      this.$emit("select", this.solicitud.IdSolicitud);
    },

    anular(event) {
      event.stopPropagation();
      this.$emit("anular", this.solicitud);
    },

    desasociar(event) {
      event.stopPropagation();
      this.$emit("desasociarRemito", this.solicitud, this.solicitud.NroRemito);
    },

    borrar(event) {
      event.stopPropagation();
      this.$emit("borrar", this.solicitud);
    }
  }
};
</script>

<style scoped>
.selectable {
  cursor: pointer;
}

.not_selected {
  border-top: 0px !important;
}
.username {
  font-size: 14px;
  font-weight: bold;
  text-align: left;
}
.ns_dominio {
  font-size: 12px;
  font-weight: 100;
  color: #878585;
  text-align: left;
}
.tag {
  position: absolute;
  top: 18px;
  right: 10px;
}

.triangleRight,
.triangleDown {
  width: 0;
  height: 0;
  border-style: solid;
  cursor: pointer;
}
.triangleRight {
  border-width: 8px 0 8px 13.9px;
  border-color: transparent transparent transparent var(--main-color);
}
.triangleDown {
  border-width: 13.9px 8px 0 8px;
  border-color: var(--main-color) transparent transparent transparent;
}

.iconContainer {
  cursor: pointer;
  font-size: 19px;
}

.iconContainer.checkContainer {
  position: absolute;
  top: -12.5px;
  right: -1px;
  background-color: var(--main-color);
  border-radius: 20px;
  width: 30px;
  height: 30px;
  color: white;
}

.iconContainer.checkContainer > .el-icon-check {
  padding: 5px;
}

.el-icon-document-delete {
  font-size: 17px;
  margin-top: 3px;
  margin-left: 1px;
  cursor: pointer;
}

.cardBody {
  padding-left: 25px;
}

.cardContent {
  text-align: left !important;
  margin-top: 8px;
}

.greyLabel {
  font-size: 14px;
  color: #6b6b6b;
  text-align: left;
  font-weight: normal;
}
.blackLabel {
  font-size: 14px;
  color: black;
  text-align: left;
  font-weight: bold;
}
tr {
  height: 20px;
}
</style>
